export default __webpack_public_path__ + "static/avatar-andy-gray-59fb283b75df2280e299f37cf80c8f68.jpg";